import React, { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import PageHeader from "components/headers/PageHeader";
import FooterCard from "components/footers/PageFooter";
import HotelCard from "components/home-cards/HotelCard.js";
import HotelStats from "components/other-cards/HotelStats";
import EnquiryCard from "components/home-cards/EnquiryCard";

export default () => {

  useEffect(() => {
    document.body.style.overflow = 'auto'
  });

  return (
    <AnimationRevealPage>
      <PageHeader pageName="Hotel & Resorts" titleName="" />
      <HotelStats />
      <HotelCard />
      <EnquiryCard />
      <FooterCard />
    </AnimationRevealPage>
  );
};
